import { Component } from '@theme/component';

class ThorneProductPicker extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bindPicker();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindPicker();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
  }

  bindPicker() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.select = this.querySelector('[data-variant-select]');
    this.subscriptionInput = this.querySelector('[data-purchase-mode="subscription"]');
    this.oneTimeInput = this.querySelector('[data-purchase-mode="one-time"]');
    if (!(this.select instanceof HTMLSelectElement) || !(this.subscriptionInput instanceof HTMLInputElement) || !(this.oneTimeInput instanceof HTMLInputElement)) return;
    this.options = Array.from(this.select.options);
    if (this.dataset.productPage === 'true') {
      const purchase = new URL(window.location.href).searchParams.get('purchase');
      if (purchase === 'one-time' && !this.oneTimeInput.disabled) {
        this.oneTimeInput.checked = true;
        this.subscriptionInput.checked = false;
      }
    }
    this.addEventListener('change', this.onSelectionChange, { signal: this.controller.signal });
    this.addEventListener('submit', this.onSubmit, { signal: this.controller.signal });
    for (const element of this.querySelectorAll('[data-enhanced-choices], [data-enhanced-summary]')) element.hidden = false;
    const fallback = this.querySelector('[data-fallback-selector]');
    if (fallback) fallback.hidden = true;
    this.renderSelection(false);
  }

  onSelectionChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && target !== this.select) return;
    if (target.matches('[data-flavor-choice], [data-pack-choice]')) {
      const flavor = this.querySelector('[data-flavor-choice]:checked')?.value;
      const pack = this.querySelector('[data-pack-choice]:checked')?.value;
      const match = this.options.find(option => option.dataset.flavor === flavor && option.dataset.pack === pack);
      this.select.value = match?.value ?? '';
    }
    this.renderSelection(true);
  };

  onSubmit = (event) => {
    const option = this.select.selectedOptions[0];
    if (!this.isPurchasable(option)) {
      event.preventDefault();
      this.renderSelection(false);
    }
  };

  isPurchasable(option) {
    if (option?.dataset.available !== 'true') return false;
    if (this.oneTimeInput.checked) return !this.oneTimeInput.disabled && this.oneTimeInput.value === '';
    return this.subscriptionInput.checked && Boolean(option.dataset.plan) && option.dataset.plan === this.dataset.planId && this.subscriptionInput.value === option.dataset.plan;
  }

  renderSelection(updateUrl) {
    const option = this.select.selectedOptions[0];
    const subscription = this.subscriptionInput.checked;
    const mode = subscription ? 'subscription' : 'oneTime';
    const button = this.querySelector('[data-add-button]');
    const unavailable = this.querySelector('[data-unavailable-message]')?.textContent ?? '';
    const soldOut = this.querySelector('[data-sold-out-message]')?.textContent ?? unavailable;
    const monthly = this.querySelector('[data-monthly-label]')?.textContent ?? '';
    const once = this.querySelector('[data-once-label]')?.textContent ?? '';
    if (button) button.disabled = !this.isPurchasable(option);
    for (const figure of this.querySelectorAll('[data-variant-media]')) figure.hidden = figure.dataset.variantMedia !== option?.value;
    const recurringTerms = this.querySelector('[data-subscription-terms]');
    const onceTerms = this.querySelector('[data-one-time-terms]');
    const pending = this.querySelector('[data-subscription-pending]');
    if (recurringTerms) recurringTerms.hidden = !subscription;
    if (onceTerms) onceTerms.hidden = subscription;
    if (pending) pending.hidden = !subscription || Boolean(option?.dataset.plan);

    for (const radio of this.querySelectorAll('[data-flavor-choice]')) radio.checked = radio.value === option?.dataset.flavor;
    for (const radio of this.querySelectorAll('[data-pack-choice]')) radio.checked = radio.value === option?.dataset.pack;
    const fields = {
      '[data-current-price]': 'Price',
      '[data-current-unit]': 'Unit',
      '[data-current-saving]': 'Save',
      '[data-current-summary]': 'Summary',
      '[data-add-label]': 'Cta',
    };
    for (const [selector, key] of Object.entries(fields)) {
      const node = this.querySelector(selector);
      if (node) node.textContent = option?.dataset[mode + key] ?? '';
    }
    const cta = this.querySelector('[data-add-label]');
    if (cta && (!option || option.dataset.available !== 'true')) cta.textContent = option ? soldOut : unavailable;
    const frequency = this.querySelector('[data-current-frequency]');
    if (frequency) frequency.textContent = subscription ? monthly : once;
    for (const label of this.querySelectorAll('[data-mode-price]')) {
      label.textContent = option?.dataset[label.dataset.modePrice === 'subscription' ? 'subscriptionPrice' : 'oneTimePrice'] ?? '';
    }
    for (const label of this.querySelectorAll('[data-pack-price], [data-pack-unit]')) {
      const pack = label.dataset.packPrice ?? label.dataset.packUnit;
      const match = this.options.find(candidate => candidate.dataset.pack === pack && candidate.dataset.flavor === option?.dataset.flavor);
      label.textContent = label.hasAttribute('data-pack-price') ? `${match?.dataset[mode + 'Price'] ?? ''}${subscription ? ` ${monthly}` : ''}` : (match?.dataset[mode + 'Unit'] ?? '');
    }
    if (updateUrl && this.dataset.productPage === 'true' && option) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      if (subscription && option.dataset.plan) url.searchParams.set('selling_plan', option.dataset.plan);
      else url.searchParams.delete('selling_plan');
      if (subscription) url.searchParams.delete('purchase');
      else url.searchParams.set('purchase', 'one-time');
      history.replaceState({}, '', url);
    }
  }
}

if (!customElements.get('thorne-product-picker')) customElements.define('thorne-product-picker', ThorneProductPicker);

